/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {useSelector} from "react-redux";
import {useSafeState} from "../../../Hooks/useSafeState";
import {GuidUtils} from "../../../Utils";
import {PermitFieldEditor} from "../ServiceDrivenEditors";
import {useDebouncedIsValidNewOption} from "../../../Hooks/useDebouncedIsValidNewOption";


export const ConservationActionPermitFieldEditor = (props) => {
	const { 
		CustomData = {},
		Data,
		...remainingProps 
	} = props;
	const {
		filter = null,
		OnUpdateModel,
		onValidateItem = (inputValue) => true,
		organizationId,
		permitTypeId,
	} = CustomData;
	
	const {
		conservationAction: conservationActionIdFromContext = null,
		conservationActionContextNodeId: contextNodeIdFromContext = null,
	} = useSelector(state => state.contextState.context);
	
	const [inputValue, setInputValue] = useSafeState('');
	
	const [isValidNewOption, isLoading] = useDebouncedIsValidNewOption(onValidateItem, inputValue, 500);
	
	const ensurePermitHasConservationActionPermit = (permit, existingConservationActionPermit) => {
		
		const {
			conservationActionPermitId,
			conservationActionId = conservationActionIdFromContext,
			contextNodeId = contextNodeIdFromContext, // required for PermitModal's FileUploadFieldEditor
			_tempId,
		} = existingConservationActionPermit ?? {};
		
		if (permit.ConservationActionPermits?.find?.(x => x.conservationActionId === conservationActionId)) {
			return permit;
		}
		
		return {
			...permit,
			ConservationActionPermits: [
				...(permit.ConservationActionPermits ?? []),
				{
					conservationActionPermitId,
					conservationActionId,
					contextNodeId, // required for PermitModal's FileUploadFieldEditor
					_tempId: _tempId ?? GuidUtils.Generate(),
				}
			]
		}
	}

	const onUpdateModel = (permit) => {
		// if we already have this ConservationActionPermit, update the existing
		// one, so we retain the historical primary key
		const existingConservationActionPermit = props?.Data ?? {};
		
		permit = ensurePermitHasConservationActionPermit(permit, existingConservationActionPermit);
		
		const conservationActionPermit = {
			...existingConservationActionPermit,
			// NOTE: 0 is used for _tempId models so that 
			// RequiredValidator treats them as valid (see 1f076dc1)
			permitId: permit.permitId ?? (permit._tempId ? '0' : null),
			Permit: {
				...permit,
				organizationId: organizationId,
				permitTypeId: permitTypeId,
			},
		};
		OnUpdateModel(conservationActionPermit);
	}
	
	if(!permitTypeId) {
		return <div className="sb-autocomplete-subtext">Please specify a Permit Type in the Survey Editor.</div>;
	}

	return <PermitFieldEditor
		// this forces the ServiceDrivenFieldEditor to refetch the Permit model
		// and re-render whenever the permitId or modified date changes
		key={`${Data?.Permit?.permitId}-${Data?.Permit?.modified}`}
		
		// context={{organizationId}}
		Data={Data}
		{...remainingProps}
		
		filter={filter}
		
		additionalSearchParams={{
			permitTypeId: permitTypeId ?? null,
		}}
		
		OnUpdate={() => {}}
		OnUpdateModel={onUpdateModel}
		
		onInputChange={setInputValue}
		isLoading={isLoading}
		isValidNewOption={isValidNewOption}
		getNewOptionData={(inputValue, label) =>
			({
				permitNumber: inputValue,
				_tempId: GuidUtils.Generate(),
				label: label
			})
		}
	/>	
}

